import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import type { GraphModalInstance } from '../../../components/GraphModal/GraphModal';
import { IconWarning } from '../../../components/icons/Icons';
import { confirmationToast, failureToast } from '../../../components/Toast';
import { useWebsite } from '../../../hooks/useWebsite';
import { markSpam } from '../../api/message';
import { ThreadOptionsStructure } from '../ThreadOptionStructure';

const messages = defineMessages({
  confirmSpam: { defaultMessage: 'Are you sure you want to report it as spam', id: 'fWSSIX' },
  reportComplete: { defaultMessage: 'The content has been reported', id: 'q/TkdC' },
  reportFailure: { defaultMessage: 'Unable to report content', id: '/atm3i' },
  spam: { defaultMessage: 'Report as spam', id: 'IKGt2J' },
});

export const SpamOption: React.FC<{
  threadId: string;
  commentId: string;
  tip?: GraphModalInstance;
}> = ({ threadId, commentId, tip }) => {
  const { formatMessage } = useIntl();
  const { id: websiteId = '' } = useWebsite();

  const report = useCallback(async () => {
    // @todo: make our own confirm box
    // eslint-disable-next-line no-restricted-globals, no-alert
    if (!confirm(formatMessage(messages.confirmSpam))) return;
    try {
      await markSpam({ websiteId, threadId, commentId });
      confirmationToast(formatMessage(messages.reportComplete));
    } catch (_) {
      failureToast(formatMessage(messages.reportFailure));
    }
    tip?.hide();
  }, [formatMessage, tip, websiteId, threadId, commentId]);

  return (
    <ThreadOptionsStructure
      icon={<IconWarning className="w-4 h-4 text-current" />}
      title={formatMessage(messages.spam)}
      onClick={report}
    />
  );
};
